/**
 * Partner session storage keys + logout event.
 *
 * Standalone MP app: the source coordinated mutual-exclusion between the main
 * app session and the marketing-partner session. There is no main session here,
 * so the `MAIN_*` keys, `MAIN_LOGOUT_EVENT` and `clearMainSession()` have been
 * removed — only the partner session remains.
 *
 * NOTE: storage keys are kept identical to the source for now. The `mp_*`
 * key-prefixing (to avoid colliding with the main app on the same domain) is a
 * single atomic sweep in the hardening step.
 */

export const PARTNER_TOKEN_KEY = 'mp_partnerServiceToken';
export const PARTNER_USER_KEY = 'mp_partnerUser';

export const PARTNER_LOGOUT_EVENT = 'session:partner:logout';

export const clearPartnerSession = () => {
    if (!localStorage.getItem(PARTNER_TOKEN_KEY)) return;
    localStorage.removeItem(PARTNER_TOKEN_KEY);
    localStorage.removeItem(PARTNER_USER_KEY);
    window.dispatchEvent(new Event(PARTNER_LOGOUT_EVENT));
};
